import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import * as R from 'ramda';
import { addServiceData, updateServiceData, deleteServiceData } from '../../../../../actions/services-api';
import ServiceData from '../../../../../constants/models/serviceData';
import Generic from '../../../../../constants/models/servicePayloads/generic';
import { ConnectionTypes, convertConnectionTypesToServiceType } from '../../../../../constants/utils/connectionTypes';
import { useDispatch, useSelector } from 'react-redux';
import * as Loadings from '../../../../../constants/loadings/service';

export const Box = ({ isCollapsed, setServiceOnFocus, branch, contractReference, setContractReference, inputOnFocus, connectionType, boxIndex, setSearchFilter }) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const user = useSelector(state => state.user);
    const services = useSelector(state => state.services);
    const [payloads, setPayloads] = useState({items: [{id: '', payload: new Generic({reference: '', comment: ''})}]});
    const [toDelete, setToDelete] = useState([]);
    const [autoFocus, setAutoFocus] = useState(false);

    let addressName = (!R.isNil(branch.address.streetAddress) ? branch.address.streetAddress : '') + (!R.isNil(branch.address.streetAddress2) ? ' ' + branch.address.streetAddress2 : '') + (!R.isNil(branch.address.streetAddress3) ? ' ' + branch.address.streetAddress3 : '') + (!R.isNil(branch.address.postalCode) && !R.isNil(branch.address.addressLocality) ? ',' + branch.address.postalCode + ' ' + branch.address.addressLocality : '') + (!R.isNil(branch.address.addressCountry) ? ', ' + countries.getName(branch.address.addressCountry, "fr", {select: "official"}) : '');
    function loadReferences(){
        let allServicesWithSameBranch = !R.isNil(services) && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) ? services.serviceData[connectionType].filter(b => b.serviceId === branch.id) : [];
        let tmpPayloads = {items: payloads.items.filter(i => toDelete.findIndex(d => d === i.id) === -1)};
        allServicesWithSameBranch.forEach(br => {
            if (tmpPayloads.items.findIndex(tmp => tmp.id === br.id) === -1){
                tmpPayloads.items.push({id: br.id, payload: br.payload});
            }
        });
        if (allServicesWithSameBranch.length > 0 && tmpPayloads.items.length > 0){
            if(tmpPayloads.items[0].payload.reference === ''){
                tmpPayloads.items.splice(0,1);
            }
            setPayloads(tmpPayloads);
        }
        setToDelete([]);
    }

    useEffect(() => {
        loadReferences();
        $('[data-toggle="tooltip"]').tooltip();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        loadReferences();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [!R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType], !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType].length]);


    let fieldName = "Référence";
    if(connectionType === ConnectionTypes.socialNetworks){
        fieldName = "Nom d'utilisateur, adresse e-mail ou téléphone";
    }else if(connectionType === ConnectionTypes.homeService){
        fieldName = "Référence ou nº CESU";
    }else if(connectionType === ConnectionTypes.multimedia){
        fieldName = "Référence ou adresse e-mail";
    }else if(connectionType === ConnectionTypes.technology){
        fieldName = "Référence ou adresse e-mail";
    }else if(connectionType === ConnectionTypes.music){
        fieldName = "Référence ou adresse e-mail";
    }else if(connectionType === ConnectionTypes.poleEmploi){
        fieldName = "Numéro d'adhérent";
    }else if(connectionType === ConnectionTypes.socialSecurity){
        fieldName = "Numéro de Sécurité Sociale";
    }else if(connectionType === ConnectionTypes.caf){
        fieldName = "Numéro d'allocataire";
    }else if(connectionType === ConnectionTypes.taxes){
        fieldName = "Numéro fiscal";
    }

    if (isCollapsed) {
        return (
            <div className="card rounded border-common flex-xl-row picker-card" onClick={() => {
                setServiceOnFocus(branch.id);
            }}>
                <div className="card-header py-3 flex-xl-column text-center align-items-center">
                    <h3 className={"h6 text-uppercase font-weight-bolder mb-0" + (R.isNil(addressName) || addressName.trim() === '' ? ' my-auto' : ' mt-auto')}>{branch.name}</h3>
                    {
                        !R.isNil(branch.address.addressLocality) && branch.address.addressLocality.trim() !== '' ?
                            <div className="mw-100 mt-2 mb-auto small align-items-start mw-100 lh-copy"><i className="eva eva-home-outline mr-1 h4 lh-1 mb-auto align-middle"></i><span className="o-70">
                                {branch.address.addressLocality === "Invalid" ? "Lien de connexion" : branch.address.addressLocality}
                            </span></div>
                            : ''
                    }
                </div>
            </div>
        );
    }

    return (
        <form className={"card rounded border-dim flex-xl-row picker-card active shadow align-self-center grid-column-lg-4"} id={branch.id} ref={inputRef}>
            <div className="card-header py-4 py-xl-3 flex-xl-column text-center align-items-center col-xl-5">
                <h3 className={"h6 text-uppercase font-weight-bolder mw-100" + (R.isNil(addressName) || addressName.trim() === '' ? ' my-auto' : ' mt-auto')}>{connectionType === ConnectionTypes.socialSecurity ? "CPAM" : connectionType === ConnectionTypes.poleEmploi ? "Pôle Emploi": branch.name}</h3>
                {
                    addressName.indexOf('Pas d\'adresse') > -1 || addressName.indexOf('00000') > -1 ? 
                        <div className="mw-100 mt-2 mb-auto small align-items-start mw-100 lh-copy">{/*<i className="eva eva-home-outline mr-1 h4 lh-1 mb-auto align-middle"></i>*/}<span className="o-70">&nbsp;</span></div>
                    :
                        !R.isNil(addressName) && addressName.trim() !== '' ? <div className="mw-100 mt-2 mb-auto small align-items-start mw-100 lh-copy"><i className="eva eva-home-outline mr-1 h4 lh-1 mb-auto align-middle"></i><span className="o-70">{addressName}</span></div>
                            : ''
                }
            </div>


            <div className="card-body pt-0 pb-3 pt-xl-3 flex-xl-column col">
                <div className="form-block mb-2">
                {
                    connectionType === ConnectionTypes.notary ? '' :
                        payloads.items.map((br, index) => {
                            return (
                                <div className="form-row" key={connectionType + index}>
                                    <div className="col-auto form-group mb-xs">
                                        <div className="flex-row gx-2 align-items-center mb-1">
                                            <label htmlFor={"reference" + index + '-' + boxIndex} className="label h6 lh-root font-weight-bold">{fieldName}</label>
                                            <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Une référence permet à vos organismes de vous identifier afin de faire les démarches nécessaires."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p>
                                        </div>
                                        <input pattern=".*\S+.*" required={true} autoFocus={inputOnFocus || (autoFocus && index === payloads.items.length - 1)} type="text" className="form-control rounded" id={"reference" + index + '-' + boxIndex} placeholder="xxxxxxxxxxx" aria-describedby="basic-addon2" value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.reference : ''} onChange={(e) => {
                                            e.preventDefault();
                                            let tmpPayload = JSON.parse(JSON.stringify(payloads.items));

                                            let payloadIndex = tmpPayload.findIndex((p, idx) => idx === index);
                                            if (payloadIndex !== -1) {
                                                tmpPayload[payloadIndex] = { id: br.id, payload: new Generic({ reference: e.target.value, comment: tmpPayload[payloadIndex].payload.comment }) };
                                            }
                                            else {
                                                tmpPayload.push({ id: '', payload: new Generic({ reference: e.target.value, comment: '' }) });
                                            }
                                            setPayloads({ ...payloads, items: tmpPayload });
                                        }} />
                                    </div>
                                    <div className="col form-group mb-xs">
                                        <div className="flex-row gx-2 align-items-center mb-1">
                                            <label htmlFor={"referenceComentaire" + index + '-' + boxIndex} className="label h6 lh-root font-weight-bold">Commentaire</label>
                                            <p className="form-text small text-gray my-auto ml-auto" data-toggle="tooltip" data-placement="top" data-html="true" data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>' title="Les cases commentaires sont personnelles (ne seront pas visibles par le mandataire), elles vous permettent d'ajouter des notes à vos services."><i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i></p>
                                        </div>
                                        <div className="input-group mb-0">
                                            <input type="text" className="form-control rounded" id={"referenceComentaire" + index + '-' + boxIndex} placeholder="xxxxxxxxxxx" value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.comment : ''} onChange={(e) => {
                                                e.preventDefault();
                                                let tmpPayload = JSON.parse(JSON.stringify(payloads.items));

                                                let payloadIndex = tmpPayload.findIndex((p, idx) => idx === index);
                                                if (payloadIndex !== -1) {
                                                    tmpPayload[payloadIndex] = { id: br.id, payload: new Generic({ reference: tmpPayload[payloadIndex].payload.reference, comment: e.target.value }) };
                                                }
                                                else {
                                                    tmpPayload.push({ id: '', payload: new Generic({ reference: '', comment: e.target.value }) });
                                                }
                                                setPayloads({ ...payloads, items: tmpPayload });
                                            }} />
                                            {(index === 0 ? br.payload.reference !== '' : true) ?
                                                <span className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none rounded" id="basic-addon2" onClick={(e) => {
                                                    e.preventDefault();
                                                    if (!R.isNil(br.id) && br.id !== '') {
                                                        let tmpToDelete = toDelete.concat(br.id);
                                                        setToDelete(tmpToDelete);
                                                        dispatch(deleteServiceData(br.id, connectionType));
                                                    }
                                                    let newPayload = payloads.items.filter((p, idx) => idx !== index);
                                                    if (newPayload.length === 0) {
                                                        newPayload.push({ id: '', payload: new Generic({ reference: '', comment: '' }) });
                                                    }
                                                    setPayloads({ ...payloads, items: newPayload });
                                                }}><i className="eva eva-trash-2-outline"></i></span>

                                                : ''}
                                        </div>
                                    </div>
                                    <div className={"col invalid-feedback alert-danger alert"}>Champs invalide</div>
                                </div>
                            )
                        })
                }
                {
                    connectionType === ConnectionTypes.notary ? '' :
                        <button type="button" className="btn btn-icon p-0 align-middle text-gray no-outline mr-auto mb-xs"
                            onClick={
                                (e) => {
                                    e.preventDefault();
                                    setPayloads({ ...payloads, items: payloads.items.concat({id:'', payload: new Generic({reference:'', comment: ''})}) });
                                    setAutoFocus(true);
                                }
                            }
                        >
                            <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary mr-1"></i>
                            <span className="btn-text aling-middle">Ajouter une autre référence</span>
                        </button>
                }
                </div>
                
                <div className={"form-footer mb-xl-6 my-xl-auto" + (connectionType === ConnectionTypes.notary ? ' align-self-center': '')} >
                    <button className={"btn btn-sm btn-alert-info border-none loading-btn"+(services.isLoading.includes(Loadings.ADD_NEW_SERVICE+branch.id) || services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA+branch.id) ? ' show': '')} 
                    disabled={services.isLoading.includes(Loadings.ADD_NEW_SERVICE+branch.id) || services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA+branch.id) } onClick={(e) => {
                        e.preventDefault();
                        if (connectionType !== ConnectionTypes.notary) {
                            inputRef.current.classList.add('was-validated');
                            if (inputRef.current.checkValidity() || (payloads.items.length === 1 && payloads.items[0].payload.reference !== '')) {
                                payloads.items.length > 0 && payloads.items.forEach(payload => {
                                    let serviceData = new ServiceData({ userId: user.user.id, serviceType: convertConnectionTypesToServiceType(connectionType), serviceId: branch.id, payload: payload.payload });
                                    if (R.isNil(payload.id) || payload.id === ''){
                                        dispatch(addServiceData(serviceData));
                                    }
                                    else{
                                        serviceData.id = payload.id;
                                        dispatch(updateServiceData(serviceData));
                                    }
                                });
                                setPayloads({payloads, items: payloads.items.filter(i => i.id !== '')});

                                setToDelete([]);
                                setSearchFilter([]);
                            }
                        }
                        else{
                            //Notaire
                            let tmpContracts = JSON.parse(JSON.stringify(contractReference));
                            tmpContracts[branch.id] = branch.id;
                            setContractReference(tmpContracts);

                            let serviceDataIndex = !R.isNil(services.serviceData[connectionType]) ? services.serviceData[connectionType].findIndex(s => s.serviceId === branch.id) : -1;
                            let serviceData = new ServiceData({ userId: user.user.id, serviceType: convertConnectionTypesToServiceType(connectionType), serviceId: branch.id, payload: new Generic({ reference: branch.id }) });
                            if (serviceDataIndex === -1) {
                                dispatch(addServiceData(serviceData));
                            }
                        }
                    }}>
                        enregistrer
                                <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                    </button>

                    {!R.isNil(contractReference[branch.id]) && contractReference[branch.id] !== '' && connectionType === ConnectionTypes.notary ?
                        <span className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none" id="basic-addon2" onClick={(e) => {
                            e.preventDefault();
                            //Notary
                            let tmpContracts = JSON.parse(JSON.stringify(contractReference));
                            tmpContracts[branch.id] = '';
                            setContractReference(tmpContracts);

                            let serviceDataIndex = !R.isNil(services.serviceData[connectionType]) ? services.serviceData[connectionType].findIndex(s => s.serviceId === branch.id) : -1;
                            if (serviceDataIndex !== -1) {
                                dispatch(deleteServiceData(services.serviceData[connectionType][serviceDataIndex].id, connectionType));
                            }
                        }}><i className="eva eva-trash-outline"></i></span>
                        : ''}
                </div>
            </div>
        </form>
    );
}